import { render, staticRenderFns } from "./previewTable.vue?vue&type=template&id=9df43210&scoped=true"
import script from "./previewTable.vue?vue&type=script&lang=js"
export * from "./previewTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9df43210",
  null
  
)

export default component.exports